export function extractRequestMetadata(source) {
  const rawStatus = source?.status;
  const parsedStatus =
    rawStatus === undefined || rawStatus === null || rawStatus === ''
      ? null
      : Number(rawStatus);

  return {
    status: Number.isNaN(parsedStatus) ? null : parsedStatus,
    correlation: source?.correlationId || source?.correlation || null,
  };
}

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function waitForMinimumLoadingTime(startedAt, minDuration) {
  const elapsed = Date.now() - startedAt;
  const remaining = Math.max(0, minDuration - elapsed);
  await delay(remaining);
}
